import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "BookClosed.svg",
  "use": "BookClosed.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"BookClosed.svg\"><path d=\"M50,56H20.4852a6,6,0,0,1-4.2425-1.7573l-3.071-3.0711A4,4,0,0,1,12,48.3432V12a2,2,0,0,1,2-2H44a2,2,0,0,1,2,2V48a2,2,0,0,1-2,2H18.8321a.5.5,0,0,0-.3535.8536l.5606.5606A2,2,0,0,0,20.4535,52H47.5a.5.5,0,0,0,.5-.5v-35a.5.5,0,0,1,.5-.5H50a2,2,0,0,1,2,2V54A2,2,0,0,1,50,56Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol